<template>
  <b-container>
    <b-row v-if="success" class="text-center pt-4">
      <b-col>
        <b-alert show variant="success">
          <p>{{ $t("info.successgeneric") }}</p>
        </b-alert>
      </b-col>
    </b-row>
    <b-form v-else @submit="onSubmit">
      <b-alert show variant="info">
        <p>{{ $t("label.pushCategory") }}</p>
        <p>
          {{ taskItemList }}
        </p>
      </b-alert>

      <b-button
        class="mt-4 text-center"
        type="submit"
        variant="success"
        :disabled="disabled"
        >{{ $t("action.submit") }}</b-button
      >

      <div v-if="error" class="pt-4">
        <b-alert show variant="info">
          <p>{{ error }}</p>
        </b-alert>
      </div>

      <div v-if="spinner" class="text-center align-middle">
        <b-spinner
          style="width: 3rem; height: 3rem"
          variant="success"
          label="Spinning"
          disabled="labelStatus"
        ></b-spinner>
      </div>
    </b-form>
  </b-container>
</template>

<script>
import axios from "axios";
import { globalF } from "../Helpers";

export default {
  mixins: [globalF],
  props: ["taskItemList", "groupBuilding"],
  data() {
    return {
      form: {},
      spinner: false,
      disabled: false,
      error: "",
      success: false,
    };
  },
  computed: {
    url: function () {
      return this.getUrl();
    },
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.error = "";
      this.spinner = true;

      let obj = {
        request: "pushLabelCategory",
        jobName: "PushLabelCategory",
        idRef: 0,
        groupBuilding: this.groupBuilding,
        taskItemList: this.taskItemList,
      };

      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          this.success = true;
          this.spinner = false;
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
  },
};
</script>
